
import Modal from 'react-modal';
import { ToastContainer } from 'react-toastify';

import Routes from './router';
import  {GlobalStyle} from "./styles/global";

Modal.setAppElement('#root');

function App() {
 
  return (
    <>
      <Routes />
      <ToastContainer autoClose={3000} />
      <GlobalStyle />
    </>


  );
}
//teste
export default App;
